import { Component } from '@angular/core';

@Component({
  selector: 'app-technokraft-engineering-works',
  templateUrl: './technokraft-engineering-works.component.html',
  styleUrls: ['./technokraft-engineering-works.component.scss']
})
export class TechnokraftEngineeringWorksComponent {

}
